import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inputWrapper", "input", "placeholder"]
  static values = {
    sourceSelector: String,
    trackingMap: Object,
    metadataUrl: String,
    stockOptionsUrl: String
  }

  connect() {
    if (this.hasInputTarget && this.inputTarget.dataset.baseDisabled === undefined) {
      this.inputTarget.dataset.baseDisabled = String(this.inputTarget.disabled)
    }

    this.sync()
  }

  async sync() {
    if (this.hasStockOptionsUrlValue) {
      const picker = this.element.querySelector("[data-hw-combobox-async-src-value]")
      if (picker) {
        const url = new URL(this.stockOptionsUrlValue, window.location.origin)
        url.searchParams.set("formula_input_id", this.sourceField()?.value || "")
        const location = document.querySelector("[name='production_order[location_id]']")
        if (location?.value) url.searchParams.set("location_id", location.value)
        picker.dataset.hwComboboxAsyncSrcValue = url.toString()
      }
    }
    const id = this.sourceField()?.value
    if (id && this.hasMetadataUrlValue && this.trackingMapValue[String(id)] === undefined) {
      const url = new URL(this.metadataUrlValue, window.location.origin)
      url.searchParams.set("id", id)
      try {
        const response = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
        if (!response.ok) return
        const data = await response.json()
        if (!this.element.isConnected || this.sourceField()?.value !== id) return
        this.trackingMapValue = { ...this.trackingMapValue, [String(id)]: data.catch_weighted }
      } catch { return }
    }
    if (!this.hasInputTarget || !this.hasInputWrapperTarget) return

    if (this.weightAvailable()) {
      this.inputWrapperTarget.classList.remove("d-none")
      this.inputTarget.disabled = this.inputTarget.dataset.baseDisabled === "true"
      this.hidePlaceholder()
      return
    }

    this.inputTarget.value = ""
    this.inputTarget.disabled = true
    this.inputWrapperTarget.classList.add("d-none")
    this.showPlaceholder()
  }

  weightAvailable() {
    const sourceField = this.sourceField()
    if (!sourceField) return false

    return this.trackingMapValue[String(sourceField.value)] === true
  }

  sourceField() {
    if (!this.hasSourceSelectorValue || !this.sourceSelectorValue) return null

    return this.element.querySelector(this.sourceSelectorValue)
  }

  showPlaceholder() {
    if (!this.hasPlaceholderTarget) return

    this.placeholderTarget.classList.remove("d-none")
  }

  hidePlaceholder() {
    if (!this.hasPlaceholderTarget) return

    this.placeholderTarget.classList.add("d-none")
  }
}
